/** biome-ignore-all lint/style/useNamingConvention: legacy */
export const ADD_USER_ASSIGNMENT_ERRORS = {
  USER_ROLE_NOT_MATCHING: 'USER_ROLE_NOT_MATCHING',
  USER_DUPLICATE: 'USER_DUPLICATE',
} as const;

export const ADD_CLASS_ASSIGNMENT_ERRORS = {
  ASSIGNMENT_DUPLICATE: 'ASSIGNMENT_DUPLICATE',
  TEACHING_UNIT_NOT_IN_CLASS: 'TEACHING_UNIT_NOT_IN_CLASS',
  INVALID_ASSIGNMENT_TYPE: 'CLASS_ASSIGNMENT_INVALID_ASSIGNMENT_TYPE',
} as const;

export const LESSON_ASSIGNMENT_ERRORS = {
  INVALID_ASSIGNMENT_TYPE: 'LESSON_ASSIGNMENT_INVALID_ASSIGNMENT_TYPE',
  LESSON_VERSIONS_NOT_FOUND_IN_ASSIGNMENT: 'LESSON_VERSIONS_NOT_FOUND_IN_ASSIGNMENT',
} as const;

export const ASSIGNMENT_ERRORS = {
  ACCESS_FORBIDDEN: 'ACCESS_FORBIDDEN',
  ASSIGNMENT_TYPE_NOT_MATCHING: 'ASSIGNMENT_TYPE_NOT_MATCHING',
  ASSIGNMENT_STYLE_NOT_MATCHING: 'ASSIGNMENT_STYLE_NOT_MATCHING',
  ASSIGNMENT_UPDATE_FORBIDDEN: 'ASSIGNMENT_UPDATE_FORBIDDEN',
  ASSIGNMENT_DRAFT_DUPLICATE: 'ASSIGNMENT_DRAFT_DUPLICATE',
  ASSIGNMENT_DRAFT_MISSING: 'ASSIGNMENT_DRAFT_MISSING',
  ASSIGNMENT_DRAFT_PUBLISH: 'ASSIGNMENT_DRAFT_PUBLISH',
  ASSIGNMENT_EMPTY: 'ASSIGNMENT_EMPTY',
  ASSIGNMENT_IN_CLASS: 'ASSIGNMENT_IN_CLASS',
  ASSIGNMENT_IN_LESSON: 'ASSIGNMENT_IN_LESSON',
  INVALID_STATUS: 'INVALID_STATUS',
} as const;

export enum ASSIGNMENT_DRAFT_PUBLISH_ERRORS {
  MINIMUM_DATA = 'MINIMUM_DATA',
  NOT_MODIFIED = 'NOT_MODIFIED',
  POINTS = 'POINTS',
  EMPTY_BLOCKS = 'EMPTY_BLOCKS',
}

export const ADD_ASSIGNMENT_ERRORS = {
  DUPLICATE: 'ASSIGNMENT_DUPLICATE',
} as const;

export const STUDENT_ASSIGNMENT_ERRORS = {
  NOT_IN_CLASS: 'ASSIGNMENT_NOT_IN_CLASS',
  SUBMISSION_DUPLICATE: 'ASSIGNMENT_SUBMISSION_DUPLICATE',
  SUBMISSION_INVALID: 'SUBMISSION_INVALID',
} as const;
